import React from 'react'
import Text from 'orionsoft-parts/lib/components/fields/Text'

export default function Password(props) {
  return <Text {...props} fieldType="password" />
}
